(() => {
  const fallbackPrices = {
    'Left Chest': {'Embroidery':4.5,'DTF Print':3.5}, 'Right Chest': {'Embroidery':4.5,'DTF Print':3.5},
    'Left Sleeve': {'Embroidery':2.5,'DTF Print':2.5}, 'Right Sleeve': {'Embroidery':2.5,'DTF Print':2.5},
    'Big Back': {'Embroidery':7.5,'DTF Print':6.5}, 'Nape of Neck': {'Embroidery':3.5,'DTF Print':2.5}
  };
  const money = n => `£${Number(n).toFixed(2)}`;
  document.querySelectorAll('[data-wwp]').forEach(root => {
    if (root.dataset.ready) return;
    root.dataset.ready = '1';
    const section = root.closest('product-info') || root.closest('section');
    const form = section?.querySelector('form[data-type="add-to-cart-form"]');
    const selected = new Map();
    const cards = [...root.querySelectorAll('.wwp-card')];
    const types = [...root.querySelectorAll('[data-type]')];
    let mode = 'none', addon = null, pending = false;
    let basePricePence = Number(root.dataset.basePrice || 0);
    try { addon = JSON.parse(root.querySelector('[data-wwp-addon]')?.textContent || 'null'); } catch (_) {}
    const addonVariant = (position, method) => addon?.variants?.find(v => v.option1 === method && v.option2 === position);
    const price = (position, method) => {
      const variant = addonVariant(position, method);
      return variant ? Number(variant.price) / 100 : fallbackPrices[position][method];
    };
    const err = root.querySelector('.wwp-error');
    const showError = message => { err.textContent = message; err.hidden = false; };
    const render = () => {
      const express = form?.querySelector('.shopify-payment-button');
      if (express) express.hidden = mode !== 'none';
      let extra = 0;
      selected.forEach((method, position) => { extra += price(position, method); });
      types.forEach(b => {
        const pressed = b.dataset.type === mode;
        b.classList.toggle('is-selected', pressed);
        b.setAttribute('aria-pressed', String(pressed));
      });
      root.querySelectorAll('[data-positions-method]').forEach(group => {
        group.hidden = !(mode === 'both' || mode === group.dataset.positionsMethod);
      });
      cards.forEach(card => {
        const {pos, method} = card.dataset;
        const pressed = selected.get(pos) === method;
        card.classList.toggle('is-selected', pressed);
        card.setAttribute('aria-pressed', String(pressed));
        const variant = addonVariant(pos, method);
        card.disabled = !!addon && (!variant || !variant.available);
        card.querySelector('.wwp-summary').textContent = card.disabled ? 'Unavailable' : `+${money(price(pos, method))}`;
      });
      const box = root.querySelector('.wwp-selected');
      box.hidden = selected.size === 0;
      const rows = box.querySelector('div');
      rows.replaceChildren();
      selected.forEach((method, position) => {
        const row = document.createElement('span');
        row.textContent = `${position} · ${method} +${money(price(position, method))}`;
        rows.append(row);
      });
      root.querySelector('[data-wwp-total]').textContent = money(extra);
      root.querySelector('.wwp-dtf-note').hidden = ![...selected.values()].includes('DTF Print');
      // Shopify replaces the price markup when a colour or size changes.
      const priceContainer = section?.querySelector('[id^="price-"]');
      const regular = priceContainer?.querySelector('.price__regular .price-item--regular');
      const sale = priceContainer?.querySelector('.price__sale .price-item--sale');
      const priceHost = priceContainer?.querySelector('.price')?.classList.contains('price--on-sale') ? sale : regular;
      if (priceHost) priceHost.textContent = money(basePricePence / 100 + extra);
    };
    types.forEach(button => button.addEventListener('click', () => {
      mode = button.dataset.type;
      if (mode === 'none') selected.clear();
      else if (mode !== 'both') selected.forEach((method, position) => { if (method !== mode) selected.delete(position); });
      err.hidden = true;
      render();
    }));
    cards.forEach(card => card.addEventListener('click', () => {
      const {pos, method} = card.dataset;
      if (selected.get(pos) === method) selected.delete(pos);
      else selected.set(pos, method); // One decoration method per position.
      err.hidden = true;
      render();
    }));
    if (!addon) {
      fetch(`${window.Shopify?.routes?.root || '/'}products/${root.dataset.addonHandle}.js`)
        .then(r => { if (!r.ok) throw Error(); return r.json(); })
        .then(product => { addon = product; render(); }).catch(() => {});
    }
    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
      subscribe(PUB_SUB_EVENTS.variantChange, event => {
        if (String(event.data.sectionId) !== root.dataset.sectionId) return;
        if (event.data.variant) basePricePence = Number(event.data.variant.price);
        render();
      });
    }
    // Keep legacy decoration variants at their garment-only value.
    setTimeout(() => {
      section?.querySelectorAll('variant-selects .product-form__input').forEach(field => {
        const name = (field.querySelector('legend, label')?.textContent || '').toLowerCase();
        if (!/embroidery|haft|personalisation|personalization|logo/.test(name)) return;
        const radio = [...field.querySelectorAll('input[type="radio"]')].find(i => /no logo|default/i.test(i.value));
        const select = field.querySelector('select');
        const option = select && [...select.options].find(o => /no logo|default/i.test(o.value));
        if (radio && !radio.checked) radio.click();
        if (option && select.value !== option.value) { select.value = option.value; select.dispatchEvent(new Event('change', {bubbles:true})); }
        field.hidden = true;
      });
    }, 80);
    if (form) {
      // Express checkout bypasses separate personalisation add-ons.
      form.addEventListener('submit', async event => {
        if (mode === 'none') return;
        event.preventDefault();
        event.stopImmediatePropagation();
        if (pending) return;
        err.hidden = true;
        if (!selected.size) { showError('Please select at least one logo position, or choose No Logo.'); return; }
        pending = true;
        const button = form.querySelector('[type="submit"]');
        const wasDisabled = button?.disabled;
        if (button) button.disabled = true;
        try {
          const route = window.Shopify?.routes?.root || '/';
          if (!addon) {
            const response = await fetch(`${route}products/${root.dataset.addonHandle}.js`);
            if (!response.ok) throw Error('Logo personalisation is currently unavailable. Please contact us for help.');
            addon = await response.json();
          }
          const fd = new FormData(form), variantId = Number(fd.get('id')), qty = Number(fd.get('quantity') || 1), props = {};
          if (!variantId || !Number.isInteger(qty) || qty < 1) throw Error('Please choose an available size and quantity.');
          for (const [key, value] of fd.entries()) if (key.startsWith('properties[')) props[key.slice(11,-1)] = value;
          const items = [{id:variantId, quantity:qty, properties:{...props, 'Logo personalisation':[...selected].map(([p,m]) => `${p} – ${m}`).join(', ')}}];
          for (const [position, method] of selected) {
            const variant = addonVariant(position, method);
            if (!variant || !variant.available) throw Error(`The ${method} option for ${position} is currently unavailable. Please choose another position.`);
            items.push({id:variant.id, quantity:qty, properties:{'_For product':document.title.split('–')[0].trim(), Position:position, Method:method}});
          }
          const response = await fetch(`${route}cart/add.js`, {method:'POST', headers:{'Content-Type':'application/json', Accept:'application/json'}, body:JSON.stringify({items})});
          if (!response.ok) { const result = await response.json(); throw Error(result.description || 'Could not add to cart. Please try again.'); }
          location.href = `${route}cart`;
        } catch (error) { showError(error.message); }
        finally { pending = false; if (button) button.disabled = wasDisabled; }
      }, true);
    }
    render();
  });
})();
